import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ProspectService from "services/Setup/Organization/ProspectServices/prospectService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  loadingDeDup: false,
  loadingProspectList: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  resultUpdateProspect: {},
  resultPostProspect: {},
  ProspectList: [],
  DeDupProspectList: {},
  CalculateContract: {},
  loadingCalculateContract: false,
  CalculateAge: {},
  loadingCalculateAge: false,
  IsProspectPosted: false,
  IsProspectUpdated: false,
  prospectID: "",
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  AddProspectFormValues: {},
};

export const getProspectList = createAsyncThunk(
  "Prospect/getProspectList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ProspectService.getProspectList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCalculateContractSLice = createAsyncThunk(
  "Prospect/getCalculateContract",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ProspectService.getCalculateContract(userInput);
      console.log("CalculateContract response", response);
      
      if (response.status === 200) {
        if (response && response.data) {
          console.log("CalculateContract response.data", response.data);
          return response.data;
        }
      } else {
        // console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCalculateAge = createAsyncThunk(
  "Prospect/getCalculateAge",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ProspectService.getCalculateAge(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postDeDupProspectList = createAsyncThunk(
  "Prospect/postDeDupProspectList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ProspectService.postDeDupProspectList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postProspect = createAsyncThunk(
  "Prospect/postProspect",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProspectService.postProspect(data);
      // console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateProspect = createAsyncThunk(
  "Prospect/updateProspect",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProspectService.updateProspect(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const proceedProspect = createAsyncThunk(
  "Prospect/proceedProspect",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProspectService.proceedProspect(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const cancelProspect = createAsyncThunk(
  "Prospect/cancelProspect",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProspectService.cancelProspect(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteProspect = createAsyncThunk(
  "Prospect/deleteProspect",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProspectService.deleteProspect(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const ProspectSlice = createSlice({
  name: "prospect",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    savePrevValues: (state, action) => {
      state.AddProspectFormValues = action.payload;
    },
    resetProspectStates: () => initialState,
  },

  extraReducers: (builder) => {
    builder

      //list
      .addCase(getProspectList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProspectList.fulfilled, (state, action) => {
        // console.log("action.payloadgetProspectList:", action.payload);
        
        state.loading = false;
        state.ProspectList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getProspectList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //CalculateContract
      .addCase(getCalculateContractSLice.pending, (state) => {
        state.loadingCalculateContract = true;
        state.redirect = "";
      })
      .addCase(getCalculateContractSLice.fulfilled, (state, action) => {
        console.log("CalculateContract payload:", action.payload);
        state.loadingCalculateContract = false;
        state.CalculateContract = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCalculateContractSLice.rejected, (state, action) => {
        state.loadingCalculateContract = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //CalculateAge
      .addCase(getCalculateAge.pending, (state) => {
        state.loadingCalculateAge = true;
        state.redirect = "";
      })
      .addCase(getCalculateAge.fulfilled, (state, action) => {
        state.loadingCalculateAge = false;
        state.CalculateAge = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCalculateAge.rejected, (state, action) => {
        state.loadingCalculateAge = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //DeDup Prospect List
      .addCase(postDeDupProspectList.pending, (state) => {
        state.loading = true;
      })
      .addCase(postDeDupProspectList.fulfilled, (state, action) => {
        state.DeDupProspectList = action?.payload?.customerData;
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message;
        state.refreshList = true;
      })
      .addCase(postDeDupProspectList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //post
      .addCase(postProspect.pending, (state) => {
        state.loading = true;
        state.IsProspectPosted = false;
      })
      .addCase(postProspect.fulfilled, (state, action) => {
        state.loading = false;
        state.IsProspectPosted = true;
        state.redirect = "/";
        state.resultPostProspect = action.payload.data.status;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.prospectID = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postProspect.rejected, (state, action) => {
        state.loading = false;
        state.IsProspectPosted = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateProspect.pending, (state) => {
        state.loading = true;
        state.IsProspectUpdated = false;
      })
      .addCase(updateProspect.fulfilled, (state, action) => {
        state.loading = false;
        state.IsProspectUpdated = true;
        state.resultUpdateProspect = action.payload.data.status;
        // state.redirect = "/";
        // state.showMessage = true;
      })
      .addCase(updateProspect.rejected, (state, action) => {
        state.loading = false;
        state.IsProspectUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //proceed
      .addCase(proceedProspect.pending, (state) => {
        state.loading = true;
      })
      .addCase(proceedProspect.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(proceedProspect.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //cancel
      .addCase(cancelProspect.pending, (state) => {
        state.loading = true;
      })
      .addCase(cancelProspect.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(cancelProspect.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteProspect.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProspect.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteProspect.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  resetProspectStates,
  showNotification,
  hideNotification,
  showLoading,
  savePrevValues,
} = ProspectSlice.actions;

export default ProspectSlice.reducer;
